import { registryAPI } from '@/providers/apis/registry/registry';
import { sortByProperty } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';
import Registry from '@/routers/views/registry/registry';
import { REGISTRY_TABLE_FIELDS_LIBRARY, USER_TYPE, REGISTRY_TYPE, PERMISSION_CHECK } from '@/utils/constants';

@Component({
    name: 'content-registry',
    components: {
        Registry,
    },
})


export default class ContentRegistry extends Vue {


    // -----------------------------------------------------------
    // Properties

    private providerList: any = [];

    private filterList: any = [];

    private searchTerms: string = '';

    private tableFields: any = [];

    private registryType: string = REGISTRY_TYPE.contentRegistry;

    private title: string = 'Content Registry';

    private userType: string = '';

    private providerLogo: any = '';

    private totalCount: any = 0;
    private contentPerPgae: any = 10;
    private tenantId: string = '';
    private selectedFilter: any = {};
    private isDistrictUser: boolean = false;

    private isSuperUser: boolean = false;

    private isContentProvider: boolean = false;

    private isLoading: any = false;

    // ---------------------------------------------------------
    // Hooks

    private created() {
        this.userType = this.$access.getUserType();
        this.tenantId = this.$access.getTenantId();
        this.isDistrictUser = this.userType === USER_TYPE.districtUser;
        this.isSuperUser = this.$access.hasAllPermission;
        this.isContentProvider = this.userType === USER_TYPE.contentProvider;
        this.tableFields = (this.isSuperUser)
            ? REGISTRY_TABLE_FIELDS_LIBRARY.superUserContent : (this.isContentProvider)
                ? REGISTRY_TABLE_FIELDS_LIBRARY.contentProviderContent
                : REGISTRY_TABLE_FIELDS_LIBRARY.districtUserContent;
        const paggination = {
            offset: 0,
            limit: this.contentPerPgae,
            query: this.searchTerms,
        };
        this.fetchProvidersList(paggination);
    }

    private onSearchItemsText(value: any) {
        this.searchTerms = value;
        this.onSelectPage(0);
    }

    // ------------------------------------------------------------------------
    // Methods

    private fetchProvidersList(paggination: any) {
        this.isLoading = true;
        registryAPI.fetchContentProviderList(paggination, this.tenantId).then((data: any) => {
            this.isLoading = false;
            sortByProperty(data.contentRegistry, 'name', 'ASC');
            this.filterList = data.contentRegistry;
            this.providerList = data.contentRegistry;
            this.totalCount = data.totalCount;
        });
    }

    private showDeatils(details: any) {
        this.$store.dispatch('partnerDataStore/passSelectedData', details);
        this.$router.push({
            path: `${this.$router.currentRoute.path}/${details.id}`,
        });
    }

    private showHeaderDeatils() {
        this.$router.push({
            path: `${this.$router.currentRoute.path}/${this.providerList[0].id}`,
        });
    }

    private onSubscribe(item: any) {
        item.isSubscribed = true;
    }

    private onEnableAccess(item: any) {
        const content = item;
    }

    private onSelectPage(offsetLimit: any) {
        const selectedFilter = this.selectedFilter || {};
        const params = {
            offset: offsetLimit,
            limit: this.contentPerPgae,
            query: this.searchTerms,
        };
        if (Object.keys(selectedFilter).length) {
            this.parseFilterBody(params);
        }
        this.fetchProvidersList(params);
    }

    private onApplyFilter(filterList: any) {
        this.selectedFilter = filterList;
        this.onSelectPage(0);
    }

    private parseFilterBody(params: any) {
        const { category, audience, subject, grades, toolCateogry, groupCode } = this.selectedFilter;
        params.category = category.length ? category.toString() : null;
        params.subject = subject.length ? subject.toString() : null;
        params.grades = grades.length ? grades.toString() : null;
        params.audience = audience.length ? audience.toString() : null;
        params.tool_category = toolCateogry.length ? toolCateogry.toString() : null;
        params.groupCode = groupCode.length ? groupCode.toString() : null;
    }
}
